/* global theme */

// Import classes
import Klaviyo from './classes/klaviyo.js';
import ErrorHandling from './classes/error-handling.js';
import PinManagement from './classes/pin-management.js';
import RequestPin from './classes/request-pin.js';

// extend Modal
var modalMessage = document.getElementById('modal-message');
theme.Modals.prototype.updateMessage = function (message) {
  modalMessage.innerHTML = message;
};

// DOM elements
export var prizeQuantityFields =
  document.querySelectorAll('.js-prize-quantity');
export var prizeSelectRemaining = document.querySelectorAll(
  '.prize-select-remaining'
);
export var pinForm = document.getElementById('pin-form');
export var pinFormSubmit = document.getElementById('pin-form-submit');
export var provinceOfResidenceField = document.getElementById(
  'province-of-residence'
);
export var customPrizeContainers = document.querySelectorAll(
  '[data-custom-prize-number]'
);
export var pinCountMessaging = document.querySelectorAll(
  '.js-pin-count-messaging'
);

export var customLineItemOnePropertiesArray = [];
export var customLineItemTwoPropertiesArray = [];
export var maxPins = 10;
export var selectors = {
  pinEntryAdd: '.pin-entry-add',
  pinEntryRemove: '.pin-entry-remove',
  pinEntryError: '.pin-entry-error',
  pinEntryField: '.pin-entry-field',
};

// Instantiate classes
export var klaviyo = new Klaviyo();
export var modal = new theme.Modals('PinCampaignModal', 'pin-campaign-modal');
export var errorHandling = new ErrorHandling();
export var pinManagement = new PinManagement();
export const requestPin = new RequestPin();
